import * as gzSigninService from './signin.service';
import listenForRhinoAuthEvents from './signin.run';

export default angular.module('gazelle.components.signin', [
  'rhino.components.application',
  'angulartics',
])
  .run(listenForRhinoAuthEvents)
  .service(gzSigninService.name, gzSigninService.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/signin/signin.module.js